import { Component, OnInit } from '@angular/core';
import { DataService } from '../service/data.service';
import { Product } from '../shared/models/product';
import { UserService } from '../service/UserService';
import { Title, Meta, DomSanitizer } from '@angular/platform-browser'; 

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.scss']
})
export class HomeComponent implements OnInit {

  token: string | null = null;
  error = "";

  public productList: any[] = []; 
  public isLoading: boolean = false;
  public p: number = 1;
  public organizationSchema: any; // PROPIEDAD PARA EL SCHEMA JSON-LD
  
  // PROPIEDAD: Estado de las FAQs para la funcionalidad de acordeón
  public faqState = [
    { open: true }, // Index 0: Primera pregunta abierta por defecto
    { open: false }, // Index 1
    { open: false }  // Index 2
  ];

  constructor(private data: DataService,
              private userService: UserService,
              private titleService: Title, 
              private metaService: Meta,
              private sanitizer: DomSanitizer 
    ) { }

  ngOnInit(): void {
    // ----------------------------------------------------
    // SEO CRÍTICO: TÍTULO Y METADATOS OPTIMIZADOS
    // ----------------------------------------------------
    this.titleService.setTitle('Uniformes Oficiales Adventistas | Fábrica CAMBEN: Conquistadores, Guías Mayores, Aventureros | Envío GRATIS');

    this.metaService.addTags([
      { 
        name: 'description', 
        content: 'CAMBEN es la Fábrica Líder en uniformes y accesorios reglamentarios para clubes de Conquistadores, Guías Mayores y Aventureros. 40 años de calidad oficial. ¡Envío GRATIS en México!' 
      },
      { 
        name: 'keywords', 
        content: 'uniformes adventistas, Conquistadores, Guías Mayores, Aventureros, tienda oficial adventista, CAMBEN 40 años, insignias, parches, pañoletas, uniformes de gala, uniformes de servicio, fabrica de uniformes' 
      },
      { name: 'author', content: 'CAMBEN - Fábrica de Uniformes Oficiales' },
      
      // Open Graph (Para redes sociales)
      { property: 'og:title', content: 'CAMBEN: Uniformes Oficiales Adventistas con Envío Gratis e Internacional | Tienda Única' },
      { property: 'og:description', content: 'Proveedor líder de uniformes para Conquistadores, Guías Mayores y Aventureros. ¡Todo el material oficial en un solo lugar! Calidad respaldada por 40 años de trayectoria.' },
      { property: 'og:image', content: 'https://www.camben.com/assets/images/camben-home-share.jpg' }, 
      { property: 'og:url', content: 'https://www.camben.com/' }
    ]);
    
    // ----------------------------------------------------
    // SEO AVANZADO: JSON-LD SCHEMA ORGANIZATION
    // ----------------------------------------------------
    const organizationData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "CAMBEN: Fábrica de Uniformes Oficiales Adventistas",
        "url": "https://camben.com.mx/TiendaClubAdventista",
        "logo": "https://camben.com.mx/assets/logo-camben-oficial.png", // Reemplaza con tu URL real
        "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+52-81-8344-XXXX", // Reemplaza con tu número de contacto
            "contactType": "Ventas y Soporte Oficial"
        },
        "sameAs": [
            "URL_DE_FACEBOOK_CAMBEN", 
            "URL_DE_INSTAGRAM_CAMBEN"
        ]
    };

    // Inyecta el script JSON-LD en el DOM.
    this.organizationSchema = this.sanitizer.bypassSecurityTrustHtml(
      `<script type="application/ld+json">${JSON.stringify(organizationData)}</script>`
    );
    // ----------------------------------------------------
    
    this.token = localStorage.getItem('token');
    if(this.token != null){
        this.validationLogin(this.token);
    }
    this.getAllProducts();

  }

  // FUNCIÓN: Controla la lógica de apertura/cierre del acordeón
  toggleFaq(index: number) {
    // Implementación estilo acordeón 
    this.faqState.forEach((item, i) => {
        if (i !== index) {
            item.open = false;
        }
    });
    // Alterna el estado de la pregunta clickeada
    this.faqState[index].open = !this.faqState[index].open;
  }
  
  getAllProducts() {
    this.isLoading = true;
    this.data.getAllProduct(0, 48).subscribe((res: any) => {
      
      const rawProducts = [
        {
          "id": "EwtoaPoOahH04Qlfsdm0",
          "product": "Banda de Guías Mayores Oficial",
          "category": "Accesorios",
          "coverImage": "https://storage.googleapis.com/camben-user.appspot.com/181ba68a-0025-49b1-872f-baf11af9c954WhatsApp_Image_2024-11-13_at_12.42.31_AM__1_-removebg-preview.png?GoogleAccessId=firebase-adminsdk-sby8y@camben-user.iam.gserviceaccount.com&Expires=19230963776&Signature=QV3076pPnL1NvzBbSl5%2BTqWuYN5ksUn3EWoTBNPsa%2Bm4co%2BYDipEzDrranWEzRMt0xnlKRb3QiRjxrDMyWHt1Ra4v7LQCLR7HHZGNnIQ2wqGsruMoa76hbBHOlQ2oxlcREP9ir0nRc%2FA2IHAGyGYQYwn50%2FBqio2OEET6Ud0%2F5i6pZhMCTRsFwfSvvgwc9tJSWRVpVP1EKLo5akC%2FSj2NNlzcv%2FBAZDnZSyy%2BLmpzveIULQmeeVRFSQFOhVAgBrbXLe9KY%2BKyTGECexKjxOUY8hlD76X7ZPTAQF0RUWE3h0yoUwFsj4cIZ5QOre%2Bx2QdFCwcL3nlJDaAPe057JX%2Buw%3D%3D",
          "description": "Ideal para mostrar liderazgo y pertenencia. Incluye emblemas, bandera y espacio para personalizar con nombre.",
          "priceShop": 155.0
        },
        {
          "id": "68b90deef1437a34c8d00c90",
          "product": "Uniforme Completo Aventurero Niña",
          "category": "Aventureros",
          "coverImage": "https://storage.googleapis.com/camben-user.appspot.com/bc69c422-2ed8-458e-8d83-d3625180cdf8uniforme%20de%20aventurero%20ni%C3%B1o%20gm.jpg?GoogleAccessId=firebase-adminsdk-sby8y@camben-user.iam.gserviceaccount.com&Expires=19281915178&Signature=hny1MiWBYHcc60iY6AhC8oRrj1bF25cytuhPwBQm0AoEBV83BrH1sdqZ4xxxqsDfRmsfkc%2FFlFhn%2BiBbFb0fy8PQdyMynveRJd2x9l3yYnekU%2BV9LL5dCo2ol6E46O1HY13jKC7K7fPN1vedVBmqXznftqZoxjZhzwy2qYsB4koHGAS0dAZWvnb8hEwMRxu7gA3s3y3WRbRZAYL6sJxDs1LE37oB0nQTq6PuiWes9uk7AxJ%2FKQ8MxU96xCsKWYu%2BgFk%2F0txJjgrCHrS63%2FXilvf7mogeUPLMenTggyW2oBSNzzj%2FXjeq0mp461o3KbIyciIedsMbMhIBX0pSi8BDgQ%3D%3D", 
          "description": "Uniforme de gala completo para niña. Incluye camisa con insignias, falda línea A y accesorios oficiales.",
          "priceShop": 1780.0
        },
        {
          "id": "FwOiIaZtox7uMmRHP7nH",
          "product": "Boina Conquistadores con Logo A1",
          "category": "Accesorios",
          "coverImage": "https://storage.googleapis.com/camben-user.appspot.com/92283976-d66f-43d9-a8a6-c11e5816b5b2boina%20aventureros.png?GoogleAccessId=firebase-adminsdk-sby8y@camben-user.iam.gserviceaccount.com&Expires=19253849792&Signature=jEjBHuBk7X%2FRRSBcbDH0FiBh8oB5f%2F4FT7QJytPEvcEOWWOOTNV5vH7cer9sISkkecTK9itNjOeEYs6GagwFlN7CbR3aiWGY2psVfGunWwTzSmIaMYlPoDQqQ6J2JPtA82UIsbVZXDmUVl1JR8bbODD02GvPr8eNJISq6CLtJw9EYhgHiSCU9ClWBvSm22mFAa6XwIqwFAEQIaX%2BvRf13M3I3sioP8oYDdkVCzTgLBXjJcgjZDfEr01Isg8qgfth2E6GYfAARwLrXkZRfdt26XejjGfSbuGLuE9%2Fl%2F4WB7XOlRyH79Hp3U7XUEn8e2quvYFjjoCOm7zVPLDHt9y6xg%3D%3D",
          "description": "Boina oficial confeccionada para ceremonias y eventos. Cómoda y duradera, con emblema bordado.",
          "priceShop": 57.0
        },
        {
          "id": "VZxTJ698iqAXrNttDOpC",
          "product": "Parches de Especialidades (Set)",
          "category": "Bordados",
          "coverImage": "https://storage.googleapis.com/camben-user.appspot.com/a40e40ff-7a4a-4bba-84ee-7a325b49e439parches%20especialidades%20de%20aventureros.jpg?GoogleAccessId=firebase-adminsdk-sby8y@camben-user.iam.gserviceaccount.com&Expires=19259723422&Signature=qY1Ol%2FvI0KI%2FYLKA8xMseglR5QnPP5usNqInfA0Qrt2%2B67%2F%2B9yNlDaYO52duSjGwWEYL5Vt5GLgcXWK4t5UyCTYZqAz0RkfOoREUyDn8AZi3kk49%2FV75bTEPIrB7VG53X88%2BCcx5R5tiFOGkrG%2B3G7NhOpizY3gzFgHlr2Qf%2FWKEWuogUZo%2Bfo4SG4eefX%2Fqc1q6U5kesBH%2FTj8CVKMnDX4C8Nqp8LU2Zq8iPsDXvBO0ep8bpBlThzDI0VEXHiXE2t0DXzdYZwsz29JqdlnmvniZp%2FIl%2Fjp9tx4UKaHHLKYEzkwHQ557v8LgGQ3gd1jDNSWLZlDHxiEMwUJ7UcMXGQ%3D%3D",
          "description": "Set de parches de especialidades para cumplir con los requisitos del Club de Aventureros IASD.",
          "priceShop": 10.0
        }
      ];

      // Sanitiza todas las URLs de las imágenes
      this.productList = rawProducts.map(p => ({
        ...p,
        coverImage: this.sanitizer.bypassSecurityTrustUrl(p.coverImage as string) 
      }));
      
      this.isLoading = false;

    });
  }

  addToCart(productId: string) {
    let addToCart = this.productList.filter((item: Product) => {
      return item.id === productId;
    });
    this.data.addProductToCart(addToCart[0]);
  }

  // Se corrige la sintaxis aquí:
  validationLogin(token: string) {
    this.userService.validationLogin(token)
      .then(response => {
     // ... (Fin del archivo original)
     }); // <-- Faltaba el paréntesis y el punto y coma de cierre del .then()
  } // <-- Faltaba la llave de cierre del método validationLogin
}